<div *ngIf=" data && tableData && tableData.datasets">
    <table class="table table-bordered mt-3">
        <thead>
            <tr>
                <th>Labels</th>
                <th *ngFor="let dataset of tableData.datasets">{{ dataset.label }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let label of tableData.labels; let i = index">
                <td>{{ label }}</td>
                <td *ngFor="let dataset of tableData.datasets">{{ dataset.data[i] }}</td>
            </tr>
        </tbody>
    </table>
</div>